import React from 'react';
import { Link } from 'react-router';

import Logo from 'images/icon/logo_OMDS.svg';
import YuanyuLogo from 'images/icon/yylogo__2_.svg';

import { useMedia } from 'util/event';
import { sendContact } from 'util/analytics';

import { useCategory } from 'model/category';
import styles from './index.css';

const Footer = () => {
	const media = useMedia();
	const [{ category: categoryList }] = useCategory();

	return (
		<footer className={styles.footer}>
			{media === 'desktop' && (
				<div className={styles.map}>
					<div className={styles.service}>
						<h5>購買</h5>
						<ul>
							{categoryList.map(category => (
								<li key={category.id}>
									<Link to={`product?category_id=${category.id}`}>{category.name}</Link>
								</li>
							))}
						</ul>
					</div>
					<div className={styles.service}>
						<h5>顧客服務</h5>
						<ul>
							<li>
								<Link to="/service/order">訂貨說明</Link>
							</li>
							<li>
								<Link to="/service/refund">退換貨說明</Link>
							</li>
							<li>
								<a
									href="https://forms.gle/vSvnoQL1EqhSSSUWA"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => sendContact()}
								>
									線上商城客服中心
								</a>
							</li>
						</ul>
					</div>
					<div className={styles.service}>
						<h5>商品查詢</h5>
						<ul>
							<li>
								<Link to="/user/order">訂單出貨查詢</Link>
							</li>
							<li>
								<a
									href="https://www.t-cat.com.tw/inquire/trace.aspx"
									target="_blank"
									rel="noopener noreferrer"
								>
									配送進度查詢
								</a>
							</li>
						</ul>
					</div>
					<div className={styles.service}>
						<h5>關於我們</h5>
						<ul>
							<li>
								<a
									href="http://www.yuanyu.tw/camera/about.php"
									target="_blank"
									rel="noopener noreferrer"
								>
									公司介紹
								</a>
							</li>
							<li>
								<Link to="/about/privacy">隱私權保護條款</Link>
							</li>
							<li>
								<Link to="/about/member">會員服務條款</Link>
							</li>
						</ul>
					</div>
				</div>
			)}
			<div className={styles.bottom}>
				{media === 'desktop' ? (
					<div className={styles.contact}>
						客服電話：(02) 8751-5055 按 1 | 服務時間：周一 - 周五 08:30 -12:00 13:00 - 17:30 |
						客服信箱：inquiry_yu@yuanyu.tw
					</div>
				) : (
					<div className={styles.contact}>
						<span>客服電話：(02) 8751-5055 按 1</span>
						<span>服務時間：周一 - 周五 08:30 -12:00 13:00 - 17:30</span>
						<span>客服信箱：inquiry_yu@yuanyu.tw</span>
					</div>
				)}

				<div className={styles.trademark}>
					<div className={styles.official}>
						<a href="https://om-digitalsolutions.com/en/" target="blank" rel="noopener noreferrer">
							<img src={Logo} alt="logo" width="100" />
						</a>
						<a href="https://www.yuanyu.tw/tw" target="blank" rel="noopener noreferrer">
							<img src={YuanyuLogo} alt="yuanyuLogo" width="138" />
						</a>
					</div>
					<div>© 2019 YUANYU Group CO., LTD. All Rights Reserved. </div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
